// extracted by extract-css-chunks-webpack-plugin
module.exports = {"appointment-list":"ntqUS","list-item":"_8qQli"};